import { render, staticRenderFns } from "./EmptyCard.vue?vue&type=template&id=9c52cb4e&scoped=true&functional=true"
import script from "./EmptyCard.vue?vue&type=script&lang=js"
export * from "./EmptyCard.vue?vue&type=script&lang=js"
import style0 from "./EmptyCard.vue?vue&type=style&index=0&id=9c52cb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "9c52cb4e",
  null
  
)

export default component.exports